"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyPreview = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_1 = require("@front/layouts/default-layout/component");
const component_2 = require("@front/components/site-menu/component");
const acl_helpers_1 = require("@back/app/acl_module/acl.helpers");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
    <div class="company-preview-page">
        <div class="row">
            <div class="col-lg-12 col-12 pb-lg-5">
                <div class="mb-2">
                    <h1>${x => x.displayTitle}</h1>
                    <div class="text-zero top-right-button-container">
                    ${(0, fast_element_1.when)(x => x.canEdit, (0, fast_element_1.html) `
                        <button @click="${(x, c) => x.edit()}" type="button"
                            class="top-right-button btn btn-warning btn-lg mr-2">
                            <i class="simple-icon-pencil mr-1"></i>
                            ${'crud.edit'.t()}
                        </button>
                        `)}
                        ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `
                        <button @click="${(x, c) => x.back()}" type="button"
                            class="top-right-button btn btn-primary btn-lg">
                            ${'common.back'.t()}
                        </button>
                        `)}
                    </div>
                </div>

                ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
                <div class="row">
                    <div class="col-12">
                        <div class="card shadow-sm">
                            <div class="card-body text-center py-5">
                                <app-loader></app-loader>
                            </div>
                        </div>
                    </div>
                </div>
                `)}

                ${(0, fast_element_1.when)(x => !x.loading && x.company, (0, fast_element_1.html) `
                
                <div class="row mb-4">
                    
                    <div class="col-lg-8 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-body">
                                <h5 class="card-title text-secondary mb-4">
                                    <i class="simple-icon-briefcase mr-2"></i>
                                    ${'company.preview.section.basic_info'.t()}
                                </h5>
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-organization"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.name'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.name) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-doc"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.nip'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.nip) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-envelope"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.email'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.email) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-phone"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.phone'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.phone) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <div class="col-lg-4 mb-3">
                        <div class="card shadow-sm h-100">
                            <div class="card-body text-center">
                                <h5 class="card-title text-secondary mb-3">
                                    <i class="simple-icon-settings mr-2"></i>
                                    ${'company.preview.section.status'.t()}
                                </h5>
                                <div class="mb-4">
                                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.active; }, (0, fast_element_1.html) `
                                    <div class="icon-circle bg-light-success mx-auto mb-3">
                                        <i class="simple-icon-check text-success"></i>
                                    </div>
                                    <h6 class="text-success font-weight-bold">${'common.active'.t()}</h6>
                                    `, (0, fast_element_1.html) `
                                    <div class="icon-circle bg-light-danger mx-auto mb-3">
                                        <i class="simple-icon-close text-danger"></i>
                                    </div>
                                    <h6 class="text-danger font-weight-bold">${'common.inactive'.t()}</h6>
                                    `)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="card shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title text-secondary mb-4">
                                    <i class="simple-icon-location-pin mr-2"></i>
                                    ${'company.preview.section.location'.t()}
                                </h5>
                                <div class="row">
                                    <div class="col-md-4 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-map"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.street'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.street) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-tag"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.postalCode'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.postalCode) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-home"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.city'.t()}</small>
                                                <strong>${x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.city) || '-'; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.address; }, (0, fast_element_1.html) `
                                    <div class="col-12 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-directions"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.address'.t()}</small>
                                                <strong>${x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.address; }}</strong>
                                            </div>
                                        </div>
                                    </div>
                                    `)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                ${(0, fast_element_1.when)(x => {
    var _a, _b, _c;
    return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.website) || ((_b = x.company) === null || _b === void 0 ? void 0 : _b.description) || (((_c = x.company) === null || _c === void 0 ? void 0 : _c.modules) &&
        x.company.modules.length);
}, (0, fast_element_1.html) `
                <div class="row mb-4">
                    <div class="col-12">
                        <div class="card shadow-sm">
                            <div class="card-body">
                                <h5 class="card-title text-secondary mb-4">
                                    <i class="simple-icon-info mr-2"></i>
                                    ${'company.preview.section.additional'.t()}
                                </h5>
                                <div class="row">
                                    ${(0, fast_element_1.when)(x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.website; }, (0, fast_element_1.html) `
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-center">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-globe"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.website'.t()}</small>
                                                <strong>
                                                    <a href="${x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.website; }}" target="_blank"
                                                        class="text-primary">
                                                        ${x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.website; }}
                                                    </a>
                                                </strong>
                                            </div>
                                        </div>
                                    </div>
                                    `)}

                                    ${(0, fast_element_1.when)(x => { var _a; return ((_a = x.company) === null || _a === void 0 ? void 0 : _a.modules) && x.company.modules.length; }, (0, fast_element_1.html) `
                                    <div class="col-md-6 mb-3">
                                        <div class="d-flex align-items-start">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-grid"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.modules'.t()}</small>
                                                <div class="mt-1">
                                                    ${(0, fast_element_1.repeat)(x => x.company.modules, (0, fast_element_1.html) `
                                                    <span class="badge badge-secondary badge-sm mr-1 mb-1">${x => x}</span>
                                                    `)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    `)}
                                </div>

                                ${(0, fast_element_1.when)(x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.description; }, (0, fast_element_1.html) `
                                <div class="row mt-3">
                                    <div class="col-12">
                                        <div class="d-flex align-items-start">
                                            <div class="flex-shrink-0 mr-3">
                                                <div class="icon-circle bg-light text-muted">
                                                    <i class="simple-icon-note"></i>
                                                </div>
                                            </div>
                                            <div>
                                                <small class="text-muted d-block">${'company.description'.t()}</small>
                                                <div class="mt-2 text-dark">${x => { var _a; return (_a = x.company) === null || _a === void 0 ? void 0 : _a.description; }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                `)}
                            </div>
                        </div>
                    </div>
                </div>
                `)}
                `)}

                ${(0, fast_element_1.when)(x => !x.loading && !x.company, (0, fast_element_1.html) `
                <div class="row">
                    <div class="col-12">
                        <div class="card shadow-sm">
                            <div class="card-body text-center py-5">
                                <div class="icon-circle bg-light text-muted mx-auto mb-3"
                                    style="width: 60px; height: 60px; font-size: 1.5rem;">
                                    <i class="simple-icon-exclamation"></i>
                                </div>
                                <h5 class="text-muted">${'company.preview.noCompany'.t()}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                `)}
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.company-preview-page .top-right-button-container {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
}
.company-preview-page .icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.company-preview-page .card {
  border: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.company-preview-page .card.shadow-sm {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.company-preview-page .card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.company-preview-page .card .card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px 12px 0 0;
}
.company-preview-page .card .card-header.bg-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
}
.company-preview-page .badge {
  font-weight: 500;
  padding: 0.5em 0.8em;
  border-radius: 6px;
}
.company-preview-page .badge.badge-lg {
  font-size: 0.95rem;
  padding: 0.6em 1em;
}
.company-preview-page .badge.badge-sm {
  font-size: 0.75rem;
  padding: 0.25em 0.6em;
}
.company-preview-page .bg-light-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
  border: 1px solid rgba(40, 167, 69, 0.2);
}
.company-preview-page .bg-light-danger {
  background-color: rgba(220, 53, 69, 0.1) !important;
  border: 1px solid rgba(220, 53, 69, 0.2);
}
.company-preview-page a {
  color: #007bff;
  text-decoration: none;
}
.company-preview-page a:hover {
  text-decoration: underline;
}
.company-preview-page h1 {
  font-weight: 700;
  color: #2c3e50;
}
.company-preview-page h3, .company-preview-page h4, .company-preview-page h5 {
  font-weight: 600;
  color: #495057;
}
.company-preview-page .text-zero {
  font-size: 0;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.company-preview-page .card {
  animation: fadeInUp 0.5s ease-out;
}
.company-preview-page .text-success {
  color: #28a745 !important;
}
.company-preview-page .text-danger {
  color: #dc3545 !important;
}
.company-preview-page .text-primary {
  color: #007bff !important;
}
.company-preview-page .text-muted {
  color: #6c757d !important;
}
.company-preview-page .text-secondary {
  color: #6c757d !important;
}
.company-preview-page .text-dark {
  color: #212529 !important;
}
.company-preview-page .mr-1 {
  margin-right: 0.25rem !important;
}
.company-preview-page .mr-2 {
  margin-right: 0.5rem !important;
}
.company-preview-page .mr-3 {
  margin-right: 1rem !important;
}
.company-preview-page .mb-1 {
  margin-bottom: 0.25rem !important;
}
.company-preview-page .mb-2 {
  margin-bottom: 0.5rem !important;
}
.company-preview-page .mb-3 {
  margin-bottom: 1rem !important;
}
.company-preview-page .mb-4 {
  margin-bottom: 1.5rem !important;
}
.company-preview-page .mt-1 {
  margin-top: 0.25rem !important;
}
.company-preview-page .mt-2 {
  margin-top: 0.5rem !important;
}
.company-preview-page .mt-3 {
  margin-top: 1rem !important;
}
.company-preview-page .py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}`;
const shadowOptions = { "mode": "open" };
let CompanyPreview = class CompanyPreview extends client_1.RWSViewComponent {
    constructor(popupService) {
        super();
        this.popupService = popupService;
        this.companyId = '';
        this.company = null;
        this.loading = false;
        this.title = 'company.preview.title';
        this.canEdit = false;
        this.isSuperAdmin = false;
    }
    async connectedCallback() {
        var _a;
        super.connectedCallback();
        // Set up ACL permissions
        const isSuperAdmin = component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
        this.canEdit = isSuperAdmin || (0, acl_helpers_1.checkACL)(`${backendImport_1.ACL.aclResources.company}.${backendImport_1.ACL.aclActions.write}`, component_1.DefaultLayout.USER.acl);
        // Get company ID from route params if available
        if ((_a = this.routeParams) === null || _a === void 0 ? void 0 : _a.id) {
            this.companyId = this.routeParams.id;
        }
        else {
            this.companyId = component_1.DefaultLayout.USER.company.id;
        }
        if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            this.isSuperAdmin = true;
        }
        await this.loadCompany();
    }
    async loadCompany() {
        this.loading = true;
        try {
            let endpoint = 'company.preview';
            let routeOptions = undefined;
            // If companyId is provided (for super admin preview), add it to route params
            if (this.companyId) {
                routeOptions = {
                    routeParams: { id: this.companyId }
                };
            }
            const response = await this.apiService.back.get(endpoint, routeOptions);
            if (response && response.success) {
                this.company = response.data;
            }
            else {
                this.popupService.alert((response === null || response === void 0 ? void 0 : response.error) || 'company.preview.failedToLoad'.t());
            }
        }
        catch (error) {
            console.error('Error loading company:', error);
            this.popupService.alert('company.preview.failedToLoad'.t());
        }
        finally {
            this.loading = false;
        }
    }
    get displayTitle() {
        return this.company ? this.company.name : this.title.t();
    }
    edit() {
        var _a;
        if ((_a = this.company) === null || _a === void 0 ? void 0 : _a.id) {
            component_2.SiteMenu.goto.bind(this)(`/company/edit/${this.company.id}`);
        }
    }
    back() {
        component_2.SiteMenu.goto.bind(this)('/company/list');
    }
};
exports.CompanyPreview = CompanyPreview;
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CompanyPreview.prototype, "companyId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof backendImport_1.ICompany !== "undefined" && backendImport_1.ICompany) === "function" ? _b : Object)
], CompanyPreview.prototype, "company", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CompanyPreview.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CompanyPreview.prototype, "title", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CompanyPreview.prototype, "canEdit", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CompanyPreview.prototype, "isSuperAdmin", void 0);
exports.CompanyPreview = CompanyPreview = __decorate([
    (0, client_1.RWSView)('company-preview', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object])
], CompanyPreview);
CompanyPreview.defineComponent();
